import { createContext, useContext } from 'react';
import { isTouchEnabled } from '../../../Theme';
import { OrderProductRowLayout } from '../products/orderProductsLayout.types';

interface OrderProductsLayoutContextProps {
  layout: OrderProductRowLayout;
  containerWidth: number;
  hasTouchGrid: boolean;
  isGridInputReadOnly: boolean;
}

export const OrderProductsLayoutContext = createContext<OrderProductsLayoutContextProps>({
  layout: OrderProductRowLayout.WIDE,
  containerWidth: 0,
  hasTouchGrid: isTouchEnabled,
  isGridInputReadOnly: false,
});

export const useOrderProductsLayoutContext = () =>
  useContext<OrderProductsLayoutContextProps>(OrderProductsLayoutContext);
